module.exports = __webpack_public_path__ + "img/logo.333c19ae.png";